import { ModelBase } from '@/models/model';

class UserLessonStatusSummary extends ModelBase {
  static namespace = 'user_lesson_status_summary';

  static path = '/api/v2/user_lesson_statuses/user_summary/';
}

export default UserLessonStatusSummary.register();
